// Autogenerated
// -------------
// gulpfile.js --> generateBuildInfo

export const Build = {
    version: "6.22.33 (f4423f98f23ae8f2bd689442f95fc29e)",
    jsVersion: "59875851282d50e241d418337cfa413f093cf347",
    jsSize:  196977,
    wasmVersion: "03ff8f9208bc11b041bebc7cce39e56d",
    wasmSize: 1810179,
};
